import { downloadExcel } from 'react-export-table-to-excel';
import { useGetUsersWazuhMutation } from '../redux/features/user/usersApiSlice';

export const useDownloadUsers = () => {
  const [getWazuhUsers, { isLoading }] = useGetUsersWazuhMutation();

  const downloadUsers = async () => {
    try {
      const partnersList = await getWazuhUsers().unwrap();

      const body = partnersList.flatMap((partner) =>
        (partner.users || [])
          .filter((user) => user.role !== 'wazuh')
          .map((user) => [
            user.username,
            user.email,
            partner.name,
            user.email?.split('@')[1] || '',
          ])
      );

      downloadExcel({
        fileName: 'Registered Users',
        sheet: 'Users',
        tablePayload: {
          header: ['Name', 'Email', 'Partner', 'Domain'],
          body: body,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  return { downloadUsers, isLoading };
};
